// extracted by mini-css-extract-plugin
export default {"root":"Banner_root__PrL6v","inner":"Banner_inner__YArtg","message":"Banner_message__1CebN","elementRight":"Banner_elementRight__D6d7I"};